<template>
  <v-app>
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
  </v-app>
</template>

<script>
import moment from 'moment';
import { clearLocalStorage, getLocalUsername, getTokenDate } from 'Arch/services/LocalStorageService';
import refleshToken from 'Arch/services/RefleshToken';
import { login } from 'Arch/services/LoginService';
import router from '@/router/index';
import eventBus from './plugins/eventBus';
import NotificationMixin from './app/arch/mixins/NotificationMixin';
import encryptData from './app/arch/helpers/EncryptData';

export default {
  name: 'App',
  mixins: [NotificationMixin],
  computed: {
    isReflesh() {
      const date = getTokenDate();

      if (!date) return false;

      return moment(date, 'YYYY-MM-DDThh:mm:ssZ')
        .isSameOrBefore();
    },
  },
  mounted() {
    this.refleshDate();
  },
  created() {
    eventBus.$on('confirm-login', () => {
      this.showConfirmDialog({
        title: 'Sua sessão expirou',
        text: 'Digite sua senha para tentarmos restabelecer sua conexão',
        confirmButtonText: 'Reconectar',
        cancelButtonText: 'Sair',
        input: 'password',
        inputPlaceholder: 'Senha',
      }).then(this.validateModal);
    });
  },
  methods: {
    refleshDate() {
      if (this.isReflesh) {
        refleshToken();
      }
    },
    validateModal(res) {
      if (res.isConfirmed) {
        this.makeLogin(res.value);
      } else {
        this.leftToLogin({ response: '' });
      }
    },
    leftToLogin(err) {
      clearLocalStorage();
      this.showErrorToast({
        text: err.response.data.message,
      });
      router.push({ name: 'Login', params: { error: err.response } });
    },
    makeLogin(password) {
      const loader = this.$loading.show();
      login({
        username: getLocalUsername(),
        password: encryptData(password),
      })
        .then(
          () => {
            loader.hide();
          },
        )
        .catch((err) => {
          loader.hide();
          this.leftToLogin(err);
        });
    },
  },
};
</script>
